import { createContext } from "react";

const DEFAULT_GLOBAL_CONTEXT = {
    changeConnectionConfig: (jwt) => {},
    walletErr: null,
    setWalletErr: (err) => {},
};

export const GlobalContext = createContext(DEFAULT_GLOBAL_CONTEXT);
